import type {
  ChangelogReleaseListItem,
  ChangelogReleaseListMeta,
  ChangelogReleaseListResponse,
} from '@/api'

const emptyMeta = (): ChangelogReleaseListMeta => ({
  hasUnreadLatest: false,
  latestReleaseId: undefined,
})

const emptyResponse = (): ChangelogReleaseListResponse => ({
  data: [],
  meta: emptyMeta(),
})

const isListResponse = (
  value: unknown
): value is ChangelogReleaseListResponse =>
  typeof value === 'object' &&
  value !== null &&
  Array.isArray((value as ChangelogReleaseListResponse).data)

/** Normalise la réponse GET /changelog/releases (oazapfts renvoie le body 200). */
export const normalizeChangelogListResponse = (
  response: unknown
): ChangelogReleaseListResponse => {
  if (!response) {
    return emptyResponse()
  }

  if (Array.isArray(response)) {
    return {
      data: response as ChangelogReleaseListItem[],
      meta: emptyMeta(),
    }
  }

  if (typeof response !== 'object' || response === null) {
    return emptyResponse()
  }

  const body = response as Record<string, unknown>

  if (isListResponse(body)) {
    return {
      data: body.data ?? [],
      meta: body.meta ?? emptyMeta(),
    }
  }

  const nested = body.data
  if (typeof nested === 'object' && nested !== null && isListResponse(nested)) {
    return {
      data: nested.data ?? [],
      meta: nested.meta ?? emptyMeta(),
    }
  }

  return emptyResponse()
}
